<template>
  <div>
    <div class="divMenu">
      <div
        :class="p_node.fexpand?'divMenu01pk':'divMenu01'"
        @click="a_pk(p_node)">
        <i
          v-if="p_node.fchildren&&p_node.fchildren.length>0"
          :class="p_node.fexpand?'el-icon-arrow-down':'el-icon-arrow-right'"
          style="padding-right: 2px;"/>
        {{ p_node.fcode }}.{{ p_node.fname }}<!---{{ p_node.fexpand }}--->
      </div>
      <div v-show="p_node.fexpand" class="divMenu02">
        <Tree
          v-for="mmb in p_node.fchildren"
          :p_node="mmb"
          :key="mmb.fid"
          :a_pk="a_pk" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tree',
  props: {
    p_node: {
      type: Object,
      default: () => {
        return {}
      }
    },
    a_pk: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
    }
  },
  computed: {
    /* nodes: () => {
      console.log('06_tree.4.mounted')
    }*/
  },
  watch: {
    p_node: {
      handler(newV, oldV) {
      },
      immediate: true
    }
  },
  activiated: () => {
    // console.log('06_tree.1.activiated')
  },
  mounted: () => {
    // console.log('06_tree.4.mounted')
  },
  created: () => {
    // console.log('06_tree.3.created')
  },
  methods: {
    pkNode(node) {
      console.log('06_tree.click', node)
      node.fexpand = !node.fexpand
    }
  }
}
</script>
<style scoped>
.divMenu{
  /*color: #616569;*/
}
.divMenu01{
  color: #565a5e;
  padding: 3px;
  margin: 1px 0;
  text-wrap: nowrap;
  width: auto;/*
  border: 1px solid #dbd5d5;
  border-radius: 2px;*/
}
.divMenu01:hover{
  color: #66b0ff;
  cursor: pointer;
}
.divMenu01pk{
  color: #1776db;
  cursor: pointer;
  padding: 3px;
  margin: 1px 0;
  text-wrap: nowrap;/**
  border: 1px solid #dbd5d5;
  border-radius: 2px; */
}
.divMenu02{
  padding-left: 25px;
}
.divMenu02 p{
  padding: 10px 0;
}
.divMenu02 p:hover{
  color: #66b0ff;
  cursor: pointer;
}
.divMenu02pp{
  color: #66b0ff;
  cursor: pointer;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/06_tree.vue